import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  getBillingAmounts,
  updateBillingAmount,
} from "app/services/billingAmount/billingAmountService";

import { BASE_URL } from "static/constants";

export const billingAmountApi = createApi({
  reducerPath: "billingAmountApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: ({ query, mutation }) => ({
    getBillingAmount: query({
      queryFn: () => ({ data: getBillingAmounts() }),
    }),
    updateBillingAmount: mutation({
      queryFn: ({ _id, ...payload }) => ({
        data: updateBillingAmount(_id, payload),
      }),
      onQueryStarted: (arg, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(() => {
          dispatch(billingAmountApi.util.resetApiState());
          dispatch(billingAmountApi.endpoints.getBillingAmount.initiate());
        });
      },
    }),
  }),
});

export const { useGetBillingAmountQuery, useUpdateBillingAmountMutation } =
  billingAmountApi;
